window["$"] = window["jQuery"] = require("jquery");
import ScrollReveal from 'scrollreveal';
import gsap from "gsap/all";
import Swiper from 'swiper';
import ScrollMagic from 'scrollmagic';



var controller = new ScrollMagic.Controller();

var windowWidth = $(window).width();
$(window).resize(function(){    
    if ($(window).width() != windowWidth) {
        windowWidth = $(window).width();
        //document.location.reload(true); 
        //console.log("trigger resize")
    } 
});





$(window).on("load", function(){
  if($(window).width() > 992){
   if($('#product-info').length){
    function prOffset(){
        var offs = -120;
        if(window.innerHeight < $('#product-info').height() ){
            offs = $('#product-info').height() - window.innerHeight;
        }
        return offs;
    }

    function prDuration(){
        var dur = 0.1;
        var prRowHeight = $(".pr-row").height();
        var prHeight = $('#product-info').height();
        if(prRowHeight > prHeight  && prRowHeight > window.innerHeight){
            dur = prRowHeight - prHeight;
        }
        return dur;
    }

    console.log(prOffset());

    var scene = new ScrollMagic.Scene({
        triggerElement: '#product-info',
        triggerHook: 0,
        duration: prDuration(),
        offset: prOffset()
    })
    .setPin('#product-info')  
    .addTo(controller);
}     
}
});


function counter(){  
    $(".count-wrap li strong").each(function(){
        var $this = $(this);
        var num =  $(this).data("count");
        var counter = { var: 0 };
        gsap.to(counter,
          {
            duration: 5,
            var: num, 
            onUpdate: function () {$this.html(Math.ceil(counter.var))}, ease:"circ.out"
          }
        )
    })
}



var tl = gsap.timeline({paused: true});
if(windowWidth > 991){
    tl.fromTo(".smile-wrap", {y: "100%"}, {duration: 1, y:"0%", ease: "power4.out"});
    tl.fromTo(".right-eye", {scale: 1}, {transformOrigin: "50%", duration: 0.3, yoyo:true, repeat: 1, scaleY: 0.3,ease: "power4.out"}, "-=0.2");
    tl.fromTo(".section-about-info .info-text", {x: 200, autoAlpha: 0}, {autoAlpha: 1.2,duration: 1, x: 0,ease: "power4.out"}, "-=0.6");
}else{
    tl.fromTo(".section-about-info .info-text", {y: 100, autoAlpha: 0}, {autoAlpha: 1.2,duration: 1, y: 0,ease: "power4.out"});
    tl.fromTo(".smile-wrap", {y: "100%"}, {duration: 1, y:"0%", ease: "power4.out"}, "-=0.6");
    tl.fromTo(".right-eye", {scale: 1}, {transformOrigin: "50%", duration: 0.3, yoyo:true, repeat: 1, scaleY: 0.3,ease: "power4.out"}, "-=0.2");    
}


tl.fromTo(".count-wrap h4,.count-wrap ul", {y: 10, autoAlpha: 0}, {stagger:0.2, autoAlpha: 1, duration: 1, y: 0,ease: "power4.out"}, "-=0.6");
tl.call(counter,null, "-=0.6");
tl.fromTo(".abt-last", {x: 200, autoAlpha: 0}, {autoAlpha: 1,duration: 1, x: 0,ease: "power4.out"}, "-=1");






function myCallback (el) {
    tl.play();
}
  
ScrollReveal().reveal('.section-about-info', {opacity: null, viewFactor: 0.3, afterReveal: myCallback });
  


  ScrollReveal().reveal('.swiper-content',{delay: 500, duration: 1000, distance: '60px' });
  
  ScrollReveal().reveal('.animFade', {
      easing: "ease-out",
      opacity: 0,
      duration: 500,
      distance: '50px',
      viewFactor: 0.2
  });
  
  ScrollReveal().reveal('.fadeDelay', {
    delay: 0,
    interval: 200
  })
  



// Hero Slider
var heroSlide = new Swiper('.hero-slider', {
    duration: 4000,
    speed: 1000,  
    autoplay: {
        delay: 7000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },   
    pagination: {
        clickable: true,
        el: '.section-hero .swiper-pagination',
    }
});

if($(window).width() < 992){
var mobSlide = new Swiper('.mob-slide', {
        effect: "fade",
  fadeEffect: {
   crossFade: true,
 },
 clickable: true,
 speed: 1000,
 pagination: {
        clickable: true,
        el: '.swiper-pagination',
    }
    
    });
}


//Dropdown Position
function dropdown(el){
    $(el).each(function(){
         $(this).parent().addClass("hasDropdown");
        $(this).css("left",  -Math.abs($(this).parent().offset().left));
    });
}
dropdown(".main-nav .dropdown");
$(window).on("resize", function(){
    dropdown(".main-nav .dropdown");
});

$(".hamburger").click(function(event) {
    $(this).toggleClass("h-active");
    $("body").toggleClass("menu-active");
});


$(document).on("click",".menu-active .hasDropdown > a", function(e){
   e.preventDefault();
   $(this).parent().toggleClass("active-dropdown");
   $(this).parent().siblings().removeClass("active-dropdown").find(".dropdown").slideUp(500);
   $(this).next(".dropdown").stop().slideToggle(500);
});





$(document).on("click", "[data-scrollto]", function(e) {
    e.preventDefault();
    var headerHeight = $(".header-main").outerHeight() - 10;
    var scrollToElm = $(this).data("scrollto");
    var scrollPos = $("#" + scrollToElm).offset().top - headerHeight;
    $("html,body").stop().animate({ scrollTop: scrollPos }, 1000);
    $(".nav-active .visible-header .hamburger").trigger("click");
});

$(document).on("keyup", function(e) {
    if (e.keyCode === 27) {
        
    }
});